import axios from "axios";

class CepService {
  async ValidaCep(cep: string) {
    const cepLimpo = cep.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (cepLimpo.length !== 8) return false; // CEP deve conter exatamente 8 dígitos
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (response.data.erro) {
        return false;
      }
      return true;
    } catch (error) {
      console.error("Erro ao validar o CEP no ViapCep, tendando no BrasilAPI:", error);

      try {
        await axios.get(`https://brasilapi.com.br/api/cep/v2/${cepLimpo}`);
        return true;
      } catch (fallbackError: unknown) {
        if (axios.isAxiosError(fallbackError) && fallbackError.response?.status === 404) {
          return false; // CEP não encontrado na BrasilAPI
        }
        console.error("Erro ao validar o CEP no BrasilAPI:", fallbackError);
        return true;
      }
    }
  };
};

export default CepService;